// Модалът с историята на госта (справка „Гости" → клик на ред): периодът в
// хедъра. Показателите на госта идват готови от BE — по същите правила като
// реда в справката, а резервациите са редовете на „Дневник".

import type { Dayjs } from "dayjs";

/** „01.07.2026 – 30.09.2026"; период от един ден — само датата. */
export const formatPeriodRange = (start: Dayjs, end: Dayjs): string =>
  start.isSame(end, "day")
    ? start.format("DD.MM.YYYY")
    : `${start.format("DD.MM.YYYY")} – ${end.format("DD.MM.YYYY")}`;
